import React from "react";
import {
  Box,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";

import {
  Settings,
  Users,
  Wallet,
} from "lucide-react";

import BackgroundImage from "../../../assets/img/longarrow.jpg";
import LoyaltyConfigPage from "./LoyaltyConfig";
import CashoutManagement from "./Cashout";
import ReferralManagement from "./UsersWhoReferred";
import { PersonIcon } from "components/Icons/Icons";

const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);



const LoyaltyReferralManagement = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>
      <Tabs variant="enclosed">

        <TabList>
          <CustomTab icon={Users} label="Referrers" />
          <CustomTab icon={Wallet} label="CashOuts Requests" />
          <CustomTab icon={Settings} label="Configurations" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <ReferralManagement
            />
          </TabPanel>

           <TabPanel>
              <CashoutManagement
              />
            </TabPanel>
            
          <TabPanel>
            <LoyaltyConfigPage />
          </TabPanel>


        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default LoyaltyReferralManagement;